module.exports = __webpack_public_path__ + "img/banner.733e43d3.png";